// extracted by mini-css-extract-plugin
module.exports = {"loader":"Spinner_loader__3ENkM","rotate-loader":"Spinner_rotate-loader__mgZS7","visible":"Spinner_visible__4-G1H"};